/**
 *  페이지 이름
 */
export const NOTICE_PRODUCT_PAGE_NAME = {
  LIST: '상품 공지사항 리스트',
  DETAIL: '상품 공지사항 상세',
};

/**
 *  상품 공지사항 상태
 */
export const NOTICE_PRODUCT_STATUS = {
  /**
   *  활성
   */
  ACTIVE: 0,
  /**
   *  판매자가 삭제
   */
  DELETE_FROM_SELLER: 1,
  /**
   *  관리자가 삭제
   */
  DELETE_FROM_ADMIN: 2,
};

/**
 *  상품 공지사항 상태 TEXT
 */
export const NOTICE_PRODUCT_STATUS_TEXT = {
  0: '활성',
  1: '판매자가 삭제',
  2: '관리자가 삭제',
};

/**
 *  상품 공지사항 타입 SELECT 리스트
 */
export const NOTICE_PRODUCT_TYPE_SELECT_LIST = [
  {
    id: 0,
    name: '활성',
  },
  {
    id: 1,
    name: '판매자가 삭제',
  },
  {
    id: 2,
    name: '관리자가 삭제',
  },
];

/**
 *  공지사항 기간 PLACEHOLDER 텍스트
 */
export const PLACEHOLDER_TEXT_NOTICE_PRODUCT_PERIOD_DATE = 'YYYY년 M월 D일 H시 m분';
